<template>
    <div v-if="isOpen" ref="modal" class="draggable-modal-container" :style="modalStyle" @mousemove="handleDrag">
        <div class="draggable-modal-header">
            <h4 @mousedown="startDrag" @mouseup="stopDrag()">{{ modalTitle }}</h4>
            <button @click="close()"><i class="mdi mdi-window-close"></i></button>
        </div>
        <div class="draggable-modal-content">
            <slot></slot>
        </div>
    </div>
</template>
<script>
import { useOverlayZIndex } from '@/js/composables/useOverlayZIndex.ts';

export default {
    props: {
        title: {
            type: String,
            default: '',
        },
        top: {
            type: Number,
            default: 80,
        },
        left: {
            type: Number,
            default: 100,
        },
    },
    emits: ['opening', 'opened', 'closing', 'closed'],
    data() {
        return {
            isOpen: false,
            isDragging: false,
            startX: null,
            startY: null,
            modalStartPosition: null,
            modalTitle: null,
            currentTop: null,
            currentLeft: null,
            activeZIndex: null,
        };
    },
    computed: {
        modalStyle() {
            return {
                zIndex: this.activeZIndex,
                top: `${this.currentTop ?? this.top}px`,
                left: `${this.currentLeft ?? this.left}px`,
            };
        },
    },
    watch: {
        left(newVal) {
            if (!this.isOpen) {
                return;
            }

            this.currentLeft = newVal;
        },
    },
    mounted() {
        this.modalTitle = this.title;
    },
    methods: {
        allocateZIndex() {
            const { activeZIndex, allocateZIndex } = useOverlayZIndex();

            allocateZIndex();
            this.activeZIndex = activeZIndex.value;
        },
        open() {
            this.$emit('opening');
            this.allocateZIndex();
            this.currentTop = this.top;
            this.currentLeft = this.left;
            this.isOpen = true;
            this.$emit('opened');
        },
        close() {
            this.$emit('closing');
            this.isOpen = false;
            this.$emit('closed');
        },
        startDrag(e) {
            this.allocateZIndex();
            this.modalStartPosition = this.$refs.modal.getBoundingClientRect();
            this.startX = e.clientX;
            this.startY = e.clientY;
            this.isDragging = true;
        },
        handleDrag(e) {
            if (!this.isDragging) {
                return;
            }
            this.currentTop = this.modalStartPosition.y + (e.clientY - this.startY);
            this.currentLeft = this.modalStartPosition.x + (e.clientX - this.startX);
        },
        stopDrag() {
            this.isDragging = false;
            this.modalStartPosition = null;
            this.startX = null;
            this.startY = null;
        },
    },
};
</script>
<style lang="scss">
.draggable-modal-container {
    position: fixed;
    top: 80px;
    left: 100px;
    z-index: 3000;
    display: flex;
    flex-direction: column;
    border: 1px solid rgba(black, 0.1);
    border-radius: 6px;

    & > .draggable-modal-header {
        min-width: 250px;
        background: #4ea5d9;
        display: flex;
        align-items: center;
        padding: 5px 10px;
        border-bottom: 1px solid rgba(black, 0.1);
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;

        & > h4 {
            margin: 3px 0 0 0;
            font-size: 18px;
            flex: 1;
            cursor: move;
            user-select: none;
            color: white;
        }

        & > button {
            width: 24px;
            height: 24px;
            border: none;
            background: white;
            border-radius: 4px;

            &:hover {
                background: rgba(black, 0.1);
            }
        }
    }

    & > .draggable-modal-content {
        background: white;
        padding: 10px;
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
    }
}
</style>
